import { atom } from "jotai";
import type { DashboardResponse } from "@models/dashboard";

// Admin dashboard KPIs (E13-S2 / #243). null until the first successful
// fetch — the page shows its loading skeleton only while this is null, so
// background refreshes (60s poll) never flash the skeleton.
export const dashboardAtom = atom<DashboardResponse | null>(null);
